import "./storeUtm";
import { initRudderStack } from "./analytics/rudderstack-client";
import { initAnalyticsEvents } from "./analytics/events";

initRudderStack();
initAnalyticsEvents();

function initSentryWhenIdle(): void {
    void import("./sentry-blade");
}

if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    requestIdleCallback(() => initSentryWhenIdle(), { timeout: 5000 });
} else {
    setTimeout(initSentryWhenIdle, 3000);
}
import "./blade-icons";
import "./header/header-mode";
import "./header/assets";
import "./header/header-menu";
import "./header/header-dropdown";
import { initCompareFavorite } from "./marketplace/widgets/compare-favorite";
initCompareFavorite();
import "./shared/toast";

let loginModalPromise: Promise<typeof import("./shared/login-modal")> | null = null;

function handleOpenLoginModal(): void {
    loginModalPromise ??= import("./shared/login-modal");
    void loginModalPromise.then((mod) => mod.openLoginModal());
}

window.addEventListener("open-login-modal", handleOpenLoginModal);

function loadAutocompleteIfNeeded(): void {
    const hasCompactMobileHeader = document.querySelector(
        '.header__container[data-compact-mobile-header="true"]',
    );

    const hasAutocomplete =
        document.getElementById("header-autocomplete") ||
        (document.getElementById("header-autocomplete-mobile") &&
            !hasCompactMobileHeader) ||
        document.getElementById("home-autocomplete");

    if (hasAutocomplete) {
        void import("./shared/blade-autocomplete");
    }
}

function loadIntroExpandIfNeeded(): void {
    if (document.querySelector("[data-intro-toggle]")) {
        void import("./landing-model/intro-expand");
    }
}

const PAGES_WITH_ACCORDIONS = new Set([
    "home",
    "marketplace",
    "vehicle-show",
    "landing",
    "landing-model",
    "dynamic-page",
]);

function loadPageModules(): void {
    const page = document.body.dataset.page;

    if (page && PAGES_WITH_ACCORDIONS.has(page)) {
        void import("./home/accordion");
    }

    if (page === "vehicle-show") {
        void import("./vehicle-show/gallery");
        void import("./vehicle-show/calculator");
        void import("./vehicle-show/header-search");
        return;
    }

    if (page === "home") {
        void Promise.all([
            import("./home/brands-banner").then((mod) => mod.initBrandsBanner()),
            import("./home/car-visualization"),
            import("./home/press-carousel"),
            import("./home/sticky-bar"),
            import("./home/vehicle-card-carousel"),
            import("./home/locomotive-scroll"),
            import("./home/home-hero-filters")
                .then((mod) => mod.initHomeHeroFilters())
                .catch((error) => {
                    console.error("[blade-app] home-hero-filters failed", error);
                }),
        ]);
        return;
    }

    if (page === "landing") {
        void import("./landing/landing-page-header");
        return;
    }

    if (page === "landing-model") {
        void import("./landing/landing-page-header");
    }
}

loadAutocompleteIfNeeded();
loadIntroExpandIfNeeded();
loadPageModules();
